import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Box, CircularProgress } from '@mui/material';

interface PrivateRouteProps {
  children: React.ReactElement;
  requiredRole?: 'admin' | 'manager' | 'employee' | 'community';
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, requiredRole }) => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check role-based access
  if (requiredRole && user) {
    if (requiredRole === 'community') {
      if (user.role !== 'community') {
        return <Navigate to="/dashboard" replace />;
      }
    } else {
      const roleHierarchy: Record<string, number> = { admin: 3, manager: 2, employee: 1, community: 0 };
      const userRoleLevel = roleHierarchy[user.role];
      const requiredRoleLevel = roleHierarchy[requiredRole];

      if (userRoleLevel < requiredRoleLevel) {
        return <Navigate to="/dashboard" replace />;
      }
    }
  }

  return children;
};

export default PrivateRoute;
